import { isRequiredFeatureEnabled } from 'src/components/auth';
import { FeatureFlag, State } from 'src/types';

export const uploadCasesHistoryVM = (state: State) => {
  const segmentEnabled = isRequiredFeatureEnabled(
    state.features,
    FeatureFlag.FRONTEND_SEGMENT_TRACKING,
  );

  return {
    organisationId: state.organisation.organisation?.id || null,
    userId: state.globalUsers.currentUser?.id || null,
    userSystemRole:
      state.globalUsers.currentUser?.SystemRoles.map((role) => role.name) ||
      null,
    segmentEnabled,
  };
};
